import React from "react";
import LcField from "./LcField";

export default function TextField(props) {
  return (
    <LcField
      name={props.name}
      text={props.text}
      errorMessage={props.errorMessage}
      htmlFor={props.name}
    >
      <input
        className="input-md"
        id={props.name}
        type="text"
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
        value={props.value}
        {...props}
      />
    </LcField>
  );
}
